import React, { useState } from 'react'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { useGetPlaylistsQuery } from '../../../api/discoverApiSlice'
import { Avatar, Button, Skeleton, Stack, Tab, Tabs, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { useSelector } from 'react-redux'
import { selectCurrentCountry } from '../../../actions/discoverSlice'
import { playTrack } from '../../../services/MusicPlayerApi'
import SmallTrackRow from '../../track/SmallTrackRow'


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
    color: theme.palette.text.secondary,
    width: '100%',
    height: '100%',
    borderRadius: '16px',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column',
    flexDirection: 'column'
}))

export const PlaylistsFocus = () => {
    var [currentIndex, setCurrentIndex] = useState(0) 
    var [currentType, setCurrentType] = useState(0) 
    const country = useSelector(selectCurrentCountry)

    const {
        data: ranks,
        isFetching
    } = useGetPlaylistsQuery(country)


    const showNextArtist = () => {
        if (currentIndex + 1 === ranks[currentType].playlists.length || currentIndex > ranks[currentType].playlists.length) {
            setCurrentIndex(0)
        } else {
            setCurrentIndex(currentIndex + 1)
        }
    }

    const showPreviousArtist = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            setCurrentIndex(ranks[currentType].playlists.length - 1)
        } else {
            setCurrentIndex(currentIndex - 1)
        }
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentType(newValue);
    }
    
    return ranks && ranks.length > 0 && ranks[currentType].playlists && ranks[currentType].playlists.length > 0 && !isFetching
    ?
        <Item sx={{
            backgroundImage: 'url('+ranks[currentType].playlists[currentIndex]?.apple_artwork_url?.replace('{w}', '300').replace('{h}', '300')+')',
            backgroundRepeat: 'no-repeat', 
            backgroundSize: "cover", 
            backgroundPosition: 'center',
            display: 'flex',
            flexFlow: 'column',
            flexDirection: 'column' 
            }}>
            <Paper sx={{backdropFilter: 'blur(10px)  brightness(90%)', p: 1, backgroundColor: '#00000000', height: '100%', display: 'flex', flexFlow: 'column', flexDirection: 'column'}}>
            
                <Stack sx={{flex: 'none', borderBottom: 0, borderColor: 'divider', mb: 1, bgcolor: '#ffffff80', borderRadius: '24px', clipPath: 'content-box'}} >
                    <Tabs value={currentType} onChange={handleChange} aria-label="playlist tabs" centered>
                        {
                            ranks.map( (rank: any, i: number) => <Tab key={`chart_${i}`} label={rank.playlists[0].apple_chart.replaceAll('-', ' ')} />)
                        }
                    </Tabs>
                </Stack>
                <Stack direction={'row'} sx={{flex: 'none', backgroundColor: '#ffffff80', borderRadius: '24px'}} alignItems={'center'}>
                    <Button 
                        onClick={() => playTrack(ranks[currentType].playlists[currentIndex].ranks[ranks[currentType].playlists[currentIndex].ranks.length - 1].tracks.map( (track: any) => new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})), 0)}
                        color="secondary" 
                        sx={{height: '6vh', width: '3.5vh', minWidth: '3.5vh', borderRadius: '3vh', border: '.5px solid black'}} >
                        <PlayArrowIcon sx={{p:0}} htmlColor='black' />
                    </Button>
                    <Typography sx={{p: 1}}>{ranks[currentType].playlists[currentIndex]?.apple_short_description ?? ranks[currentType].playlists[currentIndex]?.apple_description}</Typography>
                    <Avatar src={ranks[currentType].playlists[currentIndex]?.apple_artwork_url?.replace('{w}', '300').replace('{h}', '300')} alt='user avatar' sx={{height: '6vh', width: '3.5vh', borderRadius: '3vh', '& img': {height: '110%'}}} />
                </Stack>
                <Stack sx={{flex: 'auto', overflow: 'hidden', overflowY: 'scroll', ml: 0, mt: 1, backgroundColor: '#ffffff80', borderRadius: '24px'}}>
                {
                    ranks[currentType].playlists[currentIndex].ranks[ranks[currentType].playlists[currentIndex].ranks.length - 1]?.tracks?.map((track: Track, i: number) => 
                        <SmallTrackRow key={i} track={track} color={'#000000'} onClick={null} />
                    )
                }
                </Stack>
                <Stack direction={'row'} sx={{flex: 'none', position: 'relative', mt: 1, backgroundColor: '#ffffff80', borderRadius: '24px', height: '24px', p: 2, mb: 2, '& a': { textDecoration: 'none'}}} alignContent={'center'}>
                    <Typography>{ranks[currentType].playlists[currentIndex].description}</Typography>
                    <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={0} sx={{width: '100%'}}>
                        <Button onClick={() => showPreviousArtist()} sx={{position: 'absolute', left: 0, ml: 1, borderRadius: '16px'}}><NavigateBeforeIcon /></Button>
                        <Typography variant='h5' sx={{fontSize: '1rem', mb:0, textAlign: 'center', '& a': {color: '#000'}}} >
                            <Link to={`playlist/${ranks[currentType].playlists[currentIndex]._id}`}>{ranks[currentType].playlists[currentIndex].apple_name.length > 30 ? ranks[currentType].playlists[currentIndex].apple_name.slice(0, 29) + '...' : ranks[currentType].playlists[currentIndex].apple_name}</Link>
                        </Typography>
                        <Button onClick={() => showNextArtist()} sx={{position: 'absolute', right: 0, mr: 1, borderRadius: '16px'}}><NavigateNextIcon /></Button>
                    </Stack>
                </Stack>
            </Paper>
        </Item>
    :
        <Skeleton variant="rectangular" width={'50%'} height={'100%'}/>
    
}
